import React, { createContext, useContext, useState, useEffect } from 'react';

const CompareContext = createContext();

export const useCompare = () => {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error('useCompare must be used within a CompareProvider');
  }
  return context;
};

export const CompareProvider = ({ children }) => {
  const [compareList, setCompareList] = useState(() => {
    // Load from localStorage on initial render
    const saved = localStorage.getItem('compareList');
    return saved ? JSON.parse(saved) : [];
  });

  // Save to localStorage whenever compareList changes
  useEffect(() => {
    localStorage.setItem('compareList', JSON.stringify(compareList));
  }, [compareList]);

  const addToCompare = (tool) => {
    if (compareList.length >= 4) {
      return { success: false, message: 'Maximum 4 tools can be compared at once' };
    }
    if (compareList.find((t) => t.id === tool.id)) {
      return { success: false, message: 'Tool already in compare list' };
    }
    setCompareList([...compareList, tool]);
    return { success: true, message: `${tool.name} added to compare` };
  };

  const removeFromCompare = (toolId) => {
    setCompareList(compareList.filter((t) => t.id !== toolId));
  };

  const isInCompare = (toolId) => {
    return compareList.some((t) => t.id === toolId);
  };

  const clearCompare = () => {
    setCompareList([]);
  };

  const toggleCompare = (tool) => {
    if (isInCompare(tool.id)) {
      removeFromCompare(tool.id);
      return { success: true, message: `${tool.name} removed from compare` };
    } else {
      return addToCompare(tool);
    }
  };

  return (
    <CompareContext.Provider
      value={{
        compareList,
        addToCompare,
        removeFromCompare,
        isInCompare,
        clearCompare,
        toggleCompare,
        compareCount: compareList.length,
      }}
    >
      {children}
    </CompareContext.Provider>
  );
};
